export var Status;
(function (Status) {
    Status["ONLINE"] = "ONLINE";
    Status["OFFLINE"] = "OFFLINE";
})(Status || (Status = {}));
export var Scope;
(function (Scope) {
    Scope["EDITOR_X"] = "editor-x";
    Scope["VIEWER"] = "viewer";
})(Scope || (Scope = {}));
export var ActivityStatus;
(function (ActivityStatus) {
    ActivityStatus[ActivityStatus["ACTIVE"] = 0] = "ACTIVE";
    ActivityStatus[ActivityStatus["IDLE"] = 1] = "IDLE";
})(ActivityStatus || (ActivityStatus = {}));
//# sourceMappingURL=domain.js.map